// Kept out of the barrel so only importers that name a loader reach these
// import() calls; the views read Work host ports.
export const loadRoutineRunChatHeader = () =>
  import('./components/RoutineRunChatHeader').then((mod) => ({
    default: mod.RoutineRunChatHeader,
  }));

export const loadCreateWorkflowApprovalCard = () =>
  import('./components/CreateWorkflowApprovalCard').then((mod) => ({
    default: mod.CreateWorkflowApprovalCard,
  }));

export const loadRoutineCreateGuidedChat = () =>
  import('./components/RoutineCreateGuidedChat').then((mod) => ({
    default: mod.RoutineCreateGuidedChat,
  }));

export const loadRoutineRecentRunsRail = () =>
  import('./components/RoutineRecentRunsRail').then((mod) => ({
    default: mod.RoutineRecentRunsRail,
  }));

export const loadWorkflowShortcutListeners = () =>
  import('./hooks/useWorkflowShortcutListeners');

export const loadRoutineOverviewPane = () =>
  import('./components/RoutineOverviewPane').then((mod) => ({
    default: mod.RoutineOverviewPane,
  }));

export const loadRoutineDockCarousel = () =>
  import('./components/RoutineDockCarousel').then((mod) => ({
    default: mod.RoutineDockCarousel,
  }));

export const loadPresetSetupDialog = () => import('./hooks/usePresetSetupDialog');
